import styled from 'styled-components'
import { maxXs } from '../../styles/breakPoints'
import background1 from './img/background-1.png'

export const Container = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url(${background1});

  width: 290px;
  height: 124px;

  span {
    margin-top: 0px !important;
    width: 248px;

    font-family: Arvo;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    text-align: center;
    color: #222222;

    b {
      font-size: 18px;
    }

    @media (${maxXs}) {
      width: 290px;
    }
  }
`
